import React from 'react';

const tabs = ['기본 작성 정보', '작업별 사전체크 항목'];

export default function Tabs({ activeIndex, setActiveIndex }) {
  return (
    <div
      style={{
        position: 'relative',
        backgroundColor: '#ddd',
        borderRadius: '8px',
        display: 'flex',
        padding: '2px',
        width: '100%',
        height: '40px',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '2px',
          left: `calc(${activeIndex * 50}% + 2px)`,
          width: 'calc(50% - 4px)',
          height: 'calc(100% - 4px)',
          backgroundColor: 'white',
          borderRadius: '6px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          transition: 'left 0.3s ease-in-out',
        }}
      ></div>

      {tabs.map((tab, index) => (
        <button
          key={index}
          onClick={() => setActiveIndex(index)}
          style={{
            flex: 1,
            zIndex: 1,
            background: 'transparent',
            border: 'none',
            fontWeight: 'bold',
            fontSize: '14px',
            cursor: 'pointer',
            color: activeIndex === index ? '#000' : '#555',
          }}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
